import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { C, Panel, Chip, Serif, Label } from "./ui";
import { INSURERS } from "./adminData";

export default function Partners() {
  const [open, setOpen] = useState(INSURERS[0].name);
  return (
    <div>
      <Label>ResQconnect Commercial</Label>
      <Serif size={26} style={{ marginTop: 4, marginBottom: 6 }}>Partners</Serif>
      <div style={{ fontSize: 12, color: C.slate, marginBottom: 18 }}>Insurer → distributor → agent hierarchy. Agent codes drive commission and lead attribution.</div>

      {INSURERS.map((ins) => {
        const isOpen = open === ins.name;
        return (
          <Panel key={ins.name} style={{ padding: 0, marginBottom: 10, overflow: "hidden" }}>
            <div onClick={() => setOpen(isOpen ? null : ins.name)} data-testid={`partner-${ins.name.toLowerCase()}`}
              style={{ display: "flex", alignItems: "center", gap: 12, padding: 16, cursor: "pointer" }}>
              {isOpen ? <ChevronDown size={18} color={C.slate} /> : <ChevronRight size={18} color={C.slate} />}
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.ink }}>{ins.name}</div>
                <div style={{ fontSize: 12, color: C.slate }}>{ins.distributors.length} distributor{ins.distributors.length > 1 ? "s" : ""}</div>
              </div>
              <Chip color={C.navy}>{ins.clients.toLocaleString()} clients</Chip>
            </div>
            {isOpen && (
              <div style={{ background: C.cream, padding: "4px 16px 16px" }}>
                {ins.distributors.map((d) => (
                  <div key={d.name} style={{ marginTop: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: C.navy, marginBottom: 6 }}>{d.name}</div>
                    {d.agents.map((a) => (
                      <div key={a.code} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "9px 12px", background: "#fff", borderRadius: 8, marginBottom: 6 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <span style={{ fontSize: 13, fontWeight: 600 }}>{a.name}</span>
                          <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: C.slate, background: C.cream, padding: "2px 7px", borderRadius: 4 }}>{a.code}</span>
                        </div>
                        <span style={{ fontSize: 12, color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>{a.clients} clients</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </Panel>
        );
      })}
    </div>
  );
}
